var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$store.getters.translationsLoaded)?_c('div',[_c('base-loader')],1):_c('div',[_c('keep-alive',[_c('active')],1),_c('snack-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }